import React from 'react';

export const GoogleDocumentResultIcon = (): React.JSX.Element => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M13.444 1H2.556C1.7 1 1 1.7 1 2.556V13.445C1 14.3 1.7 15 2.556 15H13.444C14.3 15 15 14.3 15 13.445V2.556C15 1.7 14.3 1 13.444 1ZM11.897 5.667H4.111V4.112H11.897V5.667ZM11.897 8.778H4.111V7.223H11.897V8.778ZM9.563 11.889H4.111V10.334H9.563V11.889Z"
			fill="#4286F5"
		/>
	</svg>
);
